import { ADDRESS_ERRORS } from '../constants';
import {
  isDpvMatchCodeConfirmedDroppingSecondary,
  isErrorForced,
} from './validators.utils';

const ERROR = ADDRESS_ERRORS.APT_NOT_FOUND;
const isAptNotFoundForced = isErrorForced(ERROR);

export function AddressAptNotFoundValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link(scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR] = (modelValue, viewValue) => {
        const value = modelValue || viewValue || {};
        return (
          isAptNotFoundForced(ctrl._forced) ||
          !isDpvMatchCodeConfirmedDroppingSecondary(value)
        );
      };
    },
  };
}
